import cookie from 'cookie';
import { getLanguageFromLocale } from './getLanguageFromLocale';

export function getLanguageFromExtranetCookie(): string {
  const cookies = cookie.parse(document.cookie);
  if (!cookies.ee_language) return null;
  return getLanguageFromLocale(cookies.ee_language);
}
